import { graphql } from '@/generated/gql'

export const GET_ATTACHMENT =
    graphql(`query GetAttachment($attachmentId: UUID!) {
  attachment(input: { id: $attachmentId }) {
    id
    title
    attachmentPath
    attachmentType
    size
    meetingId
    parent {
      id
      contentType
      title
      permissions
      linkedGroups {
            id
            permissions
            title
      }
      linkedMeetings {
          id
          permissions
          linkedGroups {
              permissions
          }
      }
    }
    meetingId
    attachments {
      id
      title
      attachmentPath
      meetingId
    }
    tags {
      totalCount
    }
    meeting {
      id
      title
      permissions
      creator {
        userId
      }
      linkedGroups {
        id
        title
      }
      attendees{
        user {
            id
            displayName
            fullName
            firstName
            lastName
            email
            imageUrl
            role
            isConfirmedEmail
            meetplaceId
            isConfirmedEmail
            isMeetplaceInvitationInvalid
            isMeetplaceInvitationExpired
            jobTitle
            userStatus
        }    
      }
    }
    reactions {
      reactionSymbol
    }
    comments {
      totalCount
    }
    linkedDecisions {
      id
      title
      meetingId
      owners {
        userId
        email
        user {
            id
      fullName
      firstName
      lastName
      email
      imageUrl
      role
      isConfirmedEmail
      meetplaceId
      isConfirmedEmail
      isMeetplaceInvitationInvalid
      isMeetplaceInvitationExpired
      jobTitle
      userStatus
        }
      }
    }
    linkedPolls {
      id
      question
      meetingId
    }
    linkedAttachments {
      id
      title
      meetingId
    }
    linkedMOMs {
      id
      type
      name
      meetingId
    }
    linkedNotes {
      body
      id
      meetingId
    }
    linkedAgendaItems {
      id
      name
      duration
      meetingId
      isCompleted
      speakers{
        user {
            id
      fullName
      firstName
      lastName
      email
      imageUrl
      role
      isConfirmedEmail
      meetplaceId
      isConfirmedEmail
      isMeetplaceInvitationInvalid
      isMeetplaceInvitationExpired
      jobTitle
      userStatus
        }
      }
    }
    linkedActions {
      id
      title
      dueDate
      meetingId
      parentAction {
        id
      }
      completeStatus {
        isCompleted
      }
      assignees {
        assigneeRole
        userId
        email
        meetplaceId
        user {
            id
      fullName
      firstName
      lastName
      email
      imageUrl
      role
      isConfirmedEmail
      meetplaceId
      isConfirmedEmail
      isMeetplaceInvitationInvalid
      isMeetplaceInvitationExpired
      jobTitle
      userStatus
        }
      }
      delegatees {
        assigneeRole
        userId
        email
        meetplaceId
        user {
            id
      fullName
      firstName
      lastName
      email
      imageUrl
      role
      isConfirmedEmail
      meetplaceId
      isConfirmedEmail
      isMeetplaceInvitationInvalid
      isMeetplaceInvitationExpired
      jobTitle
      userStatus
        }
      }
    }
  }
}`)

export const UNLINK_ATTACHMENT =
    graphql(`mutation unLinkAttachmentFrom($input: RemoveLinkInput!){
  unLinkAttachmentFrom(input: $input){
    attachment {
      id
      linkedDecisions {
        id
        title
        meetingId
        owners {
          userId
          email
          user {
              id
        fullName
        firstName
        lastName
        email
        imageUrl
        role
        isConfirmedEmail
        meetplaceId
        isConfirmedEmail
        isMeetplaceInvitationInvalid
        isMeetplaceInvitationExpired
        jobTitle
        userStatus
          }
        }
      }
      linkedPolls {
        id
        question
        meetingId
      }
      linkedAttachments {
        id
        title
        meetingId
      }
      linkedMOMs {
        id
        type
        name
        meetingId
      }
      linkedNotes {
        body
        id
        meetingId
      }
      linkedAgendaItems {
        id
        name
        duration
        meetingId
        isCompleted
        speakers{
          user {
              id
        fullName
        firstName
        lastName
        email
        imageUrl
        role
        isConfirmedEmail
        meetplaceId
        isConfirmedEmail
        isMeetplaceInvitationInvalid
        isMeetplaceInvitationExpired
        jobTitle
        userStatus
          }
        }
      }
      linkedActions {
        id
        parentAction {
          id
        }
        title
        dueDate
        meetingId
        completeStatus {
          isCompleted
        }
        assignees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
              id
        fullName
        firstName
        lastName
        email
        imageUrl
        role
        isConfirmedEmail
        meetplaceId
        isConfirmedEmail
        isMeetplaceInvitationInvalid
        isMeetplaceInvitationExpired
        jobTitle
        userStatus
          }
        }
        delegatees {
          assigneeRole
          userId
          email
          meetplaceId
          user {
              id
        fullName
        firstName
        lastName
        email
        imageUrl
        role
        isConfirmedEmail
        meetplaceId
        isConfirmedEmail
        isMeetplaceInvitationInvalid
        isMeetplaceInvitationExpired
        jobTitle
        userStatus
          }
        }
      }
    }
  }
}`)

export const LINK_ATTACHMENT =
    graphql(`mutation LinkAttachmentTo($input: AddLinkInput!){
  linkAttachmentTo(input: $input){
    attachment {
      id
      linkedDecisions {
    id
    title
    meetingId
    owners {
      userId
      email
      user {
          id
    fullName
    firstName
    lastName
    email
    imageUrl
    role
    isConfirmedEmail
    meetplaceId
    isConfirmedEmail
    isMeetplaceInvitationInvalid
    isMeetplaceInvitationExpired
    jobTitle
    userStatus
      }
    }
  }
  linkedPolls {
    id
    question
    meetingId
  }
  linkedAttachments {
    id
    title
    meetingId
  }
  linkedMOMs {
    id
    type
    name
    meetingId
  }
  linkedNotes {
    body
    id
    meetingId
  }
  linkedAgendaItems {
    id
    name
    duration
    meetingId
    isCompleted
    speakers{
      user {
          id
    fullName
    firstName
    lastName
    email
    imageUrl
    role
    isConfirmedEmail
    meetplaceId
    isConfirmedEmail
    isMeetplaceInvitationInvalid
    isMeetplaceInvitationExpired
    jobTitle
    userStatus
      }
    }
  }
  linkedActions {
    id
    parentAction {
      id
    }
    title
    dueDate
    meetingId
    completeStatus {
      isCompleted
    }
    assignees {
      assigneeRole
      userId
      email
      meetplaceId
      user {
          id
    fullName
    firstName
    lastName
    email
    imageUrl
    role
    isConfirmedEmail
    meetplaceId
    isConfirmedEmail
    isMeetplaceInvitationInvalid
    isMeetplaceInvitationExpired
    jobTitle
    userStatus
      }
    }
    delegatees {
      assigneeRole
      userId
      email
      meetplaceId
      user {
          id
    fullName
    firstName
    lastName
    email
    imageUrl
    role
    isConfirmedEmail
    meetplaceId
    isConfirmedEmail
    isMeetplaceInvitationInvalid
    isMeetplaceInvitationExpired
    jobTitle
    userStatus
      }
    }
  }
    }
  }
}`)

export const CREATE_ATTACHMENT = graphql(`
    mutation CreateAttachment($input: CreateAttachmentInput!) {
        createAttachmentV1(input: $input) {
            attachment {
                id
                title
                attachmentPath
                meetingId
                parentId
                parentContentType
                size
                attachmentType
            }
        }
    }
`)

export const CREATE_ATTACHMENT_ON_ACTION = graphql(`
    mutation CreateAttachmentOnAction($input: CreateAttachmentInput!) {
        createAttachmentOnActionV1(input: $input) {
            attachment {
                id
                title
                attachmentPath
                meetingId
                parentId
                parentContentType
            }
        }
    }
`)

export const PREVIEW_ATTACHMENT = graphql(`
    mutation PreviewAttachment($input: GeneratePreviewUrlInput!){
        generateMeetingAttachmentPreviewUrl(input: $input){
            previewUrl
        }
    }
`)

export const ATTACHMENT_UPDATED =
    graphql(`subscription attachmentUpdated($attachmentId: UUID!, $excludeMeetingRoomChange: Boolean) {
  attachmentUpdated(attachmentId: $attachmentId, excludeMeetingRoomChange: $excludeMeetingRoomChange) {
      attachment {
          id
          title
          attachmentPath
          parentId
        }
      }
  }`)
export const ATTACHMENT_DELETED =
    graphql(`subscription attachmentDeleted($attachmentId: UUID!) {
  attachmentDeleted(attachmentId: $attachmentId) {
      attachment {
          id
      }
      }
  }`)

export const ATTACHMENTS_BY_MEETING_ID = graphql(`
    query AttachmentsByMeetingId($meetingId: String!) {
        meetingV1(input:  {
           fakeId: $meetingId
        }) {
            meeting {
                id
                allAttachments {
                    id
                    title
                    attachmentPath
                    attachmentType
                    isArchived
                    size
                    __typename
                }
            }
        }
    }
`)
